export const host = "https://movieviewerbackend.onrender.com";
export const loginRoute = `${host}/user/login`;
export const signupRoute = `${host}/user/signup`;
export const allMovie = `${host}/movie/get-all`;
export const postMovie = `${host}/movie/post`;
export const deleteMovie = `${host}/movie`;
export const updateMovie = `${host}/movie`;